import { render } from "./Quizs.vue?vue&type=template&id=475fa8fd&scoped=true"
import script from "./Quizs.vue?vue&type=script&lang=js"
export * from "./Quizs.vue?vue&type=script&lang=js"

import "./Quizs.vue?vue&type=style&index=0&id=475fa8fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-475fa8fd"]])

export default __exports__